














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

/**
 * @displayName Base Button
 */
import { navigateTo } from 'bits/location'
@Component({})
export default class BaseButton extends Vue {
  /**
   * Determines the button's main style theme
   * @values contained, flat, text, fat-contained, fat-text
   * @default text
   */
  @Prop() variation!: string
  /**
   * Determines the color of button
   * @values default, black, white, primary
   */
  @Prop({ default: 'default' }) colorScheme!: 'default' | 'black' | 'white' | 'green' | 'orange'
  /**
   * Allows clicking the button navigate to a URL
   */
  @Prop() href!: string
  /**
   * Determines where the url should be opened in
   * @values _self, _blank
   * @default _self
   */
  @Prop({ default: '_self' }) hrefTarget!: string
  get hasIcon(): boolean {
    return !!this.$slots.icon
  }
  get hasText(): boolean {
    return !!this.$slots.default && this.$slots.default.toString().trim() !== ''
  }
  get variationClass(): string {
    switch (this.variation) {
      case 'contained':
      case 'flat':
        return 'flat-button'
      case 'text':
        return 'text-button'
      case 'fat-contained':
        return 'fat-contained-button'
      case 'small-contained':
        return 'small-contained-button'
      case 'large-contained':
        return 'large-contained-button'
      case 'fat-text':
        return 'fat-text-button'
      default:
        return 'text-button'
    }
  }
  get colorSchemeClass(): string {
    return this.colorScheme + '-color'
  }
  get classNames(): string[] {
    return [
      'button',
      !(this.hasIcon && !this.hasText) ? this.variationClass : '',
      this.colorSchemeClass,
      this.hasIcon ? 'icon-button' : '',
      this.hasText ? '' : 'button-without-text',
    ]
  }

  click(event): void {
    if (this.href) {
      navigateTo(this.href, { target: this.hrefTarget })
    }
    this.$emit('click', event)
  }
}
